/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\Company\CompanyDisplay.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Tuesday January 16th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday January 16th 2024 2:01:56 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import translator from "MultiLanguage/TranslationWrapper";
import { CompanyDataType } from "Type/company.type";
import Styles from "Content/Company/Company.module.css";
import { formatSiren } from "Utils/company.utils";

function CompanyDisplay(props: CompanyDataType) {
    const mySiren = formatSiren(props.Siren);
    return (
        <div className="d-flex gap-3">
            <div className={`${Styles.information}`}>
                <span>{translator.decode("dynamic.company")}: {props.Name}</span>
                <span>{translator.decode("dynamic.siren")}: {mySiren}</span>
                <span>{translator.decode("dynamic.createdAt")} {new Date(props.CreatedAt).toLocaleDateString()}</span>
                <span>{translator.decode("dynamic.standard")}: {props.StandardPhoneNumber}</span>
                {/* <button className="btn btn-outline-info">
                {props.KBISPath ?
                    <a href={props.KBISPath} target="_blank" >{translator.decode("dynamic.kbis")}</a>
                    :<p>{translator.decode("dynamic.kbis")}: {translator.decode("dynamic.noData")} </p>
                }
                    </button> */}
            </div>
            <div className={`${Styles.address}`}>
                <span>{translator.decode("dynamic.address")}: {props.Address}</span>
                <span>{translator.decode("dynamic.postalcode")}: {props.PostalCode}</span>
                <span>{translator.decode("dynamic.city")}: {props.City}</span>
                <span>{translator.decode("dynamic.state")}: {props.State}</span>
                <span>{translator.decode("dynamic.country")}: {props.Country}</span>
            </div>
        </div>
    )
}

export default CompanyDisplay;
